module.exports = __webpack_public_path__ + "img/payment.b0658cae.png";